import api from "../api/axios"

export const getAdminUsers = () => api.get("/admin/users").then((r) => r.data)
export const createAdminUser = (data) => api.post("/admin/users", data).then((r) => r.data)
